import { getAdminApplicationCode } from '../utils/permisos'

let adminApplicationCode = ''

export const setApplicationSession = (sessionResponse) => {
  adminApplicationCode = getAdminApplicationCode(sessionResponse) || ''
}

export const clearApplicationSession = () => {
  adminApplicationCode = ''
}

export const getCurrentAdminApplicationCode = () => adminApplicationCode
